export const MAIN_API_URL = process.env.NODE_ENV === 'production' ? "https://app.outletpark.eu" : "https://app.outletpark.eu";
export const CHECK_USER_CARD_API = '/employee/check_user_card'
export const GIVE_USER_CARD_API = '/employee/give_rewards'
export const RESET_PASSWORD_API = '/reset-password'
export const CONFIRM_REGISTER_API = '/email/verify'